import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-05_15-0-25","buildId":"24954","environment":"trackline-acceptance","datetime":"2026-11-05T14:07:06.360Z","checkForUpdates":true}